import React, { Component } from "react";
import dayjs from "dayjs";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  header: {
    marginBottom: "12pt",
    textAlign: "center",
  },
  title: {
    fontSize: "18pt",
    margin: "0 0 6pt",
  },
  headerLine: {
    margin: "3pt 0",
  },
  legendTable: {
    borderCollapse: "collapse",
    marginBottom: "10pt",
    width: "100%",
  },
  legendCell: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "center",
  },
  movementTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginBottom: "10pt",
    width: "100%",
  },
  highlightedCell: {
    backgroundColor: "#f4c181",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "center",
    verticalAlign: "top",
  },
  cell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class MouvementsRubriquePDF extends Component {
  render() {
    const { lignesMouvements, dateDu, dateAu } = this.props;

    return (
      <div style={styles.document}>
        <div style={styles.header}>
          <h1 style={styles.title}>LISTE ENTREES/SORTIES</h1>
          <p style={styles.headerLine}>
            <span>
              <strong>
                {`Période : ${dateDu.format("DD/MM/YYYY") + " "} au ${dateAu.format("DD/MM/YYYY")}`}
              </strong>
            </span>
          </p>
        </div>

        <table style={styles.legendTable}>
          <thead>
            <tr>
              <th width="30%" style={styles.legendCell}>
                <strong>Locataire</strong>
              </th>
              <th width="30%" style={styles.legendCell}>
                <strong>Lot</strong>
              </th>
              <th width="20%" style={styles.legendCell}>
                <strong>Entrée</strong>
              </th>
              <th width="20%" style={styles.legendCell}>
                <strong>Sortie</strong>
              </th>
            </tr>
          </thead>
        </table>

        {lignesMouvements.map((mouvement, i) => {
          const total = mouvement.quittance_ligne.reduce(
            (a, b) => a + parseFloat(b.quittance_ligne_montant),
            0
          );
          return (
            <table key={i} style={styles.movementTable}>
              <thead>
                <tr>
                  <th width="30%" style={styles.highlightedCell}>
                    <strong>
                      {mouvement.location_requete
                        ? `${mouvement.location_requete.requete_locataire.locataire_personne.personne_nom} ${mouvement.location_requete.requete_locataire.locataire_personne.personne_prenom}`
                        : "Blocage propriétaire"}
                    </strong>
                  </th>
                  <th width="30%" style={styles.highlightedCell}>
                    <strong>{`${mouvement.location_lot.lot_reference}`}</strong>
                  </th>
                  <th width="20%" style={styles.highlightedCell}>
                    <strong>
                      {dayjs(mouvement.location_date_debut, "YYYY-MM-DD").format("DD/MM/YYYY")}
                    </strong>
                  </th>
                  <th width="20%" style={styles.highlightedCell}>
                    <strong>
                      {dayjs(mouvement.location_date_fin, "YYYY-MM-DD").format("DD/MM/YYYY")}
                    </strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {mouvement.quittance_ligne.map((ligne, j) => (
                  <tr key={j} style={{ backgroundColor: j % 2 === 0 ? "#ffffff" : "#eeeeee" }}>
                    <td style={styles.cell}>{ligne.quittance_ligne_rubrique.rubrique_libelle}</td>
                    <td style={styles.amountCell}>
                      {parseFloat(ligne.quittance_ligne_montant).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td style={styles.cell}></td>
                    <td style={styles.cell}></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td style={styles.totalLabelCell}></td>
                  <td style={styles.totalAmountCell}>
                    <strong>
                      {parseFloat(total).toLocaleString("fr-FR", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </strong>
                  </td>
                  <td style={styles.totalLabelCell}></td>
                  <td style={styles.totalLabelCell}></td>
                </tr>
              </tfoot>
            </table>
          );
        })}
      </div>
    );
  }
}
